<!-- bonus.wxml -->
<template>
    <div class="address-box">
        <div class="address-list-box">
            <div class="address-item" v-for="(item,index) in memberAddress" :key="index">
                <input type="radio" :id="'address' + item.address_id" :value="item.address_id" class="default-input"
                       v-model="defaultAddress"/>
                <div class="address">
                    <div class="name">姓名：{{item.name}}</div>
                    <div class="tel">Tel：{{item.phone}}</div>
                    <div class="dateil">{{item.detail}} {{item.city}} {{item.province}} {{item.proper_code}}</div>
                </div>
                <div class="edit-box">
                    <div class="default" @click="setDefault(item.address_id)">
                        <label :for="'address' + item.address_id">
                            <div :class="['iconfont',item.address_id == default_id ? 'icon-duihao' : '']"></div>
                            默认地址
                        </label>
                    </div>
                    <div class="delete-btn" @click="deleteAddress(item.address_id)">
                        <div class="iconfont icon-shanchu"></div>
                        删除
                    </div>
                    <router-link :to="'/member/edit_address?address_id=' + item.address_id" class="edit-btn">
                        <div class="iconfont icon-bianji"></div>
                        编辑
                    </router-link>
                </div>
            </div>
            <!-- no-result -->
            <div class="noresult" v-if="!memberAddress.length">
                <div class="cot">
                    <div class="img">
                        <img src="../../assets/images/no_result.png">
                    </div>
                    <p class="text" style="color: #aaa;">您还没有添加任何地址</p>
                </div>
            </div>
            <!-- no-result end -->
        </div>
        <router-link to="/member/add_address" class="add-address">新增地址</router-link>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'
    export default {
        name: 'MemberAddress',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                showAdd: false, //添加地址
                defaultAddress: '',
                memberAddress: [],
                default_id: 0, // 默认地址 id
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });

        },
        mounted() { //视图加载完成执行
            let _this = this;
            // 获取收货地址列表
            _this.getAddressList();
        },
        methods: {

            /**
             * 获取收货地址列表
             */
            getAddressList: function () {
                let _this = this;
                _this._get('address/lists', {}, function (result) {
                    _this.memberAddress = result.data.list;
                    _this.default_id = result.data.default_id;
                    _this.loading.hide();
                });
            },

            /**
             * 设置为默认地址
             */
            setDefault: function (address_id) {
                let _this = this;
                _this.setData({
                    default_id: parseInt(address_id)
                });
                _this._post_form('address/setDefault', {
                    address_id
                }, function (result) {
                    _this.$toast.success('设置默认地址成功');
                });
                return false;
            },


            /**
             * 删除地址
             */
            deleteAddress: function (address_id) {
                let _this = this;
                _this.$dialog({
                    title: "您确定要移除当前收货地址吗?",
                    content: "地址删除后将从你的记录里消失，无法找回",
                    okBtnTxt: "删除",
                    onOkBtn(event){
                        _this._post_form('address/delete', {
                            address_id
                        }, function (result) {
                            if(result.code){
                                _this.$toast.success('删除成功');
                            }
                            _this.getAddressList();
                        });
                        this.close(); //关闭对话框
                    }
                });
            },

            starNumber: function (n) {
                return n.replace(n.substring(4, n.length - 4), '****');
            }
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss" scoped>
    @import "address.scss";
</style>
